<prlw-edit-trader-tariff-ui
  [shipmentBasisName]="shipmentBasisName$ | async"
  [source]="source$ | async"
  [price]="price$ | async"
  [changeSimilarProductsTariff]="changeSimilarProductsTariff$ | async"
  [deliveryMethod]="deliveryMethod$ | async"
  (eventClose)="this.eventClose.emit()"
  (eventDelete)="handleDelete()"
  (eventPrice)="setPrice($event)"
  (eventChangeChangeSimilarProductsTariff)="setChangeSimilarProductsTariff($event)"
></prlw-edit-trader-tariff-ui>
